import { Component, OnDestroy, OnInit } from '@angular/core';
import { DashboardService, LocationService, LocationServiceDto, InTransitDto, BlackboxService, BlackboxDto, JourneyItemDto, CustomerLocationDto, ActiveDashboardResponse, LocationTypeDto, ActiveDashboardRequest, DepotDto, LocationServiceResponse, LocationServiceInformationDto, LocationServiceRequest } from 'src/shared/service-proxies/service-proxies';
import { PageHelperService } from '../helpers/page-helper.service';
import { PagebaseComponent } from '../pagebase/pagebase.component';
import { ApplicationStatusService } from '../services/application-status.service';
import moment from 'moment';
import { SummaryDataItemModel } from '../models/summary-data-item-model';
import { SessionStorageService } from '../services/session-storage.service';
import { AuthService } from '../security/auth.service';
import { ServicesItemModel } from '../widgets/models';
import { DateTimeHelper } from '../helpers/datetime';
import { CustomerSettings } from '../services/customer-settings-service';

export class DropDownListItem {
  id: string;
  name: string;
}

@Component({
    selector: 'app-activity-report-component',
    templateUrl: './activity-report.component.html',
    styleUrls: ['./activity-report.component.scss'],
    standalone: false
})
export class ActivityReportComponent extends PagebaseComponent implements OnDestroy {

  // Private variables
  services: LocationServiceInformationDto[]
  servicesPage: ServicesItemModel[] = [];
  locationTypes: LocationTypeDto[] = [{ name: "Customer", id: "", classification: 0, colour: "#00c07f" }, { name: "Depot", id: "", classification: 0, colour: "#2978ff" }];
  selectedCustomerId: string;
  selectedVehicleId: string[];
  selectedTipLocationId: string[];
  selectedWasteLocationId: string[];
  selectedDepotId: string[];
  selectedWasteId: string[];
  maxDate: Date = new Date();
  selectedStartDate: Date;
  selectedEndDate: Date;
  isOnExportUsed: boolean;
  showFullDate: boolean = true;

  customerVehicles: DropDownListItem[];
  tipLocations: DropDownListItem[];
  wasteLocations: DropDownListItem[];
  customerWastes: DropDownListItem[];
  depots: DropDownListItem[];
  private apiCall;

  // Public variables
  loading: boolean = true;

  // Constuctor
  constructor(
    private _dashboardService: DashboardService,
    private blackboxService: BlackboxService,
    private sessionStorageService: SessionStorageService,
    private authService: AuthService,
    pageHelperService: PageHelperService,
    applicationStatusService: ApplicationStatusService,
    private customerSettings: CustomerSettings) {
    super(pageHelperService, applicationStatusService, customerSettings, "Active Operations");
  }

  ngOnDestroy() {
  }

  reset() {
    this.services = [];
    if (this.apiCall) {
      this.apiCall.unsubscribe();
    }
  }
  // Get the view data
  getData() {
    this.loading = true;
    this.setIsLoading(this.loading);
    var params = this.GetActiveDashboardRequest();
    this.apiCall = this._dashboardService.getServiceInformationData(
      params
    ).subscribe(data => {
      this.services = data.services;
      // this.depots = this.getDepotList(data.depots);
      this.loading = false;
      this.loadListData(data);
      this.setIsLoading(this.loading);
      this.updateView();
    }, error => {
      debugger;
    });
  }

  dropdownChanged(opened) {
    if (!opened) {
      this.getData();
    }
  }

  vehicleChange(newValue) {
    if (newValue.length > 0) {
      this.sessionStorageService.setItem("activity-report-selectedVehicleId", JSON.stringify(newValue));
    } else {
      this.sessionStorageService.removeItem("activity-report-selectedVehicleId")
    }
  }

  tipLocationChange(newValue) {
    if (newValue.length > 0) {
      this.sessionStorageService.setItem("activity-report-selectedTipLocationId", JSON.stringify(newValue));
    } else {
      this.sessionStorageService.removeItem("activity-report-selectedTipLocationId")
    }
  }

  wasteLocationChange(newValue) {
    if (newValue.length > 0) {
      this.sessionStorageService.setItem("activity-report-selectedWasteLocationId", JSON.stringify(newValue));
    } else {
      this.sessionStorageService.removeItem("activity-report-selectedWasteLocationId")
    }
  }

  wasteChange(newValue) {
    if (newValue.length > 0) {
      this.sessionStorageService.setItem("activity-report-selectedWasteId", JSON.stringify(newValue));
    } else {
      this.sessionStorageService.removeItem("activity-report-selectedWasteId")
    }
  }

  depotChange(newValue) {
    if (newValue.length > 0) {
      this.sessionStorageService.setItem("activity-report-selectedDepotId", JSON.stringify(newValue));
    } else {
      this.sessionStorageService.removeItem("activity-report-selectedDepotId")
    }
  }

  selectedEndDateChange(startDate, endDate) {
    if (startDate.value && endDate.value) {
      var startMoment = moment(startDate.value, 'DD/MM/YYYY');
      var endMoment = moment(endDate.value, 'DD/MM/YYYY');
      startDate = startMoment.toDate();
      endDate = endMoment.toDate();

      var utcStart = new Date(Date.UTC(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), 0, 0, 0));
      this.sessionStorageService.setItem("activity-report-selectedStartDate", utcStart.valueOf().toString());
      console.log(startDate)
      console.log(this.selectedStartDate)

      var utcEnd = new Date(Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), 0, 0, 0));
      this.sessionStorageService.setItem("activity-report-selectedEndDate", utcEnd.valueOf().toString());
      console.log(endDate)
      console.log(this.selectedEndDate)


      // Rset vehicle and location filters
      this.selectedVehicleId = [];
      this.selectedTipLocationId = [];
      this.selectedWasteLocationId = [];
      this.sessionStorageService.removeItem("activity-report-selectedVehicleId")
      this.sessionStorageService.removeItem("activity-report-selectedTipLocationId")
      this.sessionStorageService.removeItem("activity-report-selectedWasteLocationId")

      this.getData();
    }
  }

  getDateFromValue(newValue) {
    if (newValue == null) {
      var now = new Date();
      return new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0));
    }

    if (newValue && newValue != null) {
      var milliseconds = newValue;
      newValue = new Date(0);
      newValue.setUTCMilliseconds(milliseconds)
    } else {
      newValue = new Date();
    }

    return new Date(Date.UTC(newValue.getFullYear(), newValue.getMonth(), newValue.getDate(), 0, 0, 0));
  }

  updateView() {
    let page:  ServicesItemModel[] = [];
    this.services.forEach(service => {
        page.push(this.MapDtoToModel(service));
    });

    this.servicesPage = page;
  }


  loadListData(data: LocationServiceResponse) {
    // Get list data from the provided data
    const vehicles: DropDownListItem[] = [];
    const tipLocations: DropDownListItem[] = [];
    const wasteLocations: DropDownListItem[] = [];
    const wastes: DropDownListItem[] = [];

    data.services.forEach(service => {
      // Tip locations
      if (service.locationId != null) {
        if (!tipLocations.find(l => l.id == service.locationId)) {
          var location = new DropDownListItem()
          location.id = service.locationId;
          location.name = service.locationName;
          tipLocations.push(location)
        }
      }

      // Waste locations
      if (service.sourceLocationId != null) {
        if (!wasteLocations.find(l => l.id == service.sourceLocationId)) {
          var location = new DropDownListItem()
          location.id = service.sourceLocationId;
          location.name = service.sourceLocation;
          wasteLocations.push(location)
        }
      }      

      // Add vehicles
      if (service.vehicleId != null) {
        if (!vehicles.find(l => l.id == service.vehicleId)) {
          var vehicle = new DropDownListItem()
          vehicle.id = service.vehicleId;
          vehicle.name = service.vehicleName;
          vehicles.push(vehicle)
        }
      }

      // Add waste
      if (service.wasteId != null) {
        if (!wastes.find(l => l.id == service.wasteId.toString())) {
          var waste = new DropDownListItem()
          waste.id = service.wasteId.toString();
          waste.name = service.wasteType;
          wastes.push(waste)
        }
      }
    });

    this.customerVehicles = vehicles.sort(function (a, b) {
      if (a.name < b.name) { return -1; }
      if (a.name > b.name) { return 1; }
      return 0;
    })

    this.tipLocations = tipLocations.sort(function (a, b) {
      if (a.name < b.name) { return -1; }
      if (a.name > b.name) { return 1; }
      return 0;
    })

    this.wasteLocations = wasteLocations.sort(function (a, b) {
      if (a.name < b.name) { return -1; }
      if (a.name > b.name) { return 1; }
      return 0;
    })

    this.customerWastes = wastes.sort(function (a, b) {
      if (a.name < b.name) { return -1; }
      if (a.name > b.name) { return 1; }
      return 0;
    })    

    var selectedVehicleId = [];
    if (this.sessionStorageService.getItem("activity-report-selectedVehicleId")) {
      selectedVehicleId = JSON.parse(this.sessionStorageService.getItem("activity-report-selectedVehicleId"));
      this.selectedVehicleId = selectedVehicleId;
    }
    var selectedTipLocationId = [];
    if (this.sessionStorageService.getItem("activity-report-selectedTipLocationId")) {
      selectedTipLocationId = JSON.parse(this.sessionStorageService.getItem("activity-report-selectedTipLocationId"));
      this.selectedTipLocationId = selectedTipLocationId;
    }

    console.log(this.selectedVehicleId);
  }

  getDepotList(depots: DepotDto[]): DropDownListItem[] {
    const depotlist: DropDownListItem[] = [];
    depots.forEach(element => {
      var depot = new DropDownListItem()
      depot.id = element.id;
      depot.name = element.name;
      depotlist.push(depot)
    });

    return depotlist;
  }

  generateVehicleLocations(jobs: JourneyItemDto[]): InTransitDto[] {

    const data: InTransitDto[] = [];

    jobs.forEach(job => {
      const item: InTransitDto = {
        vehicleId: job.vehicleId,
        vehicleName: job.vehicleName,
        fromLocationId: job.fromLocationId,
        fromLocationLatitude: job.fromLocationLatitude,
        fromLocationLongitude: job.fromLocationLongitude,
        fromLocationName: job.fromLocation,
        fromLocationTypeName: job.fromLocationTypeName,
        toLocationId: job.toLocationId,
        toLocationLatitude: job.toLocationLatitude,
        toLocationLongitude: job.toLocationLongitude,
        toLocationName: job.toLocation,
        toLocationTypeName: job.toLocationTypeName,
        alert: job.alert
      }

      data.push(item);
    });

    return data;
  }

  getSummaryData(milesValue: number, servicesValue: number, jobsValue: number): SummaryDataItemModel[] {
    var items = [];
    let miles: SummaryDataItemModel = {
      Title: "Miles Driven",
      Value: (Math.round(milesValue * 10) / 10).toString()
    };
    items.push(miles);
    let services: SummaryDataItemModel = {
      Title: "Services",
      Value: servicesValue.toString()
    };
    items.push(services);
    let jobs: SummaryDataItemModel = {
      Title: "Movements",
      Value: jobsValue.toString()
    };
    items.push(jobs);
    return items;
  }

  exportToCSV() {
    this.loading = true;
    this.setIsLoading(this.loading);
    var params = this.GetActiveDashboardRequest();

    this.apiCall = this._dashboardService.getServiceInformationDataExport(
      params
    ).subscribe(data => {
      this.loading = false;
      this.setIsLoading(this.loading);
      let filename = data.fileName;
      let blob: Blob = data.data;
      let a = document.createElement('a');
      a.download = filename;
      a.href = window.URL.createObjectURL(blob);
      a.click();
    }, error => {
      debugger;
    });
  }

  GetActiveDashboardRequest() {
    var selectedStartDate = this.getDateFromValue(this.sessionStorageService.getItem("activity-report-selectedStartDate"));
    this.selectedStartDate = selectedStartDate;

    var selectedEndDate = this.getDateFromValue(this.sessionStorageService.getItem("activity-report-selectedEndDate"));
    this.selectedEndDate = selectedEndDate;

    var selectedVehicleId = [];
    if (this.sessionStorageService.getItem("activity-report-selectedVehicleId")) {
      selectedVehicleId = JSON.parse(this.sessionStorageService.getItem("activity-report-selectedVehicleId"));
      this.selectedVehicleId = selectedVehicleId;
    }
    var selectedTipLocationId = [];
    if (this.sessionStorageService.getItem("activity-report-selectedTipLocationId")) {
      selectedTipLocationId = JSON.parse(this.sessionStorageService.getItem("activity-report-selectedTipLocationId"));
      this.selectedTipLocationId = selectedTipLocationId;
    }
    var selectedWasteLocationId = [];
    if (this.sessionStorageService.getItem("activity-report-selectedWasteLocationId")) {
      selectedWasteLocationId = JSON.parse(this.sessionStorageService.getItem("activity-report-selectedWasteLocationId"));
      this.selectedWasteLocationId = selectedWasteLocationId;
    }    
    var selectedDepotId = [];
    if (this.sessionStorageService.getItem("activity-report-selectedDepotId")) {
      selectedDepotId = JSON.parse(this.sessionStorageService.getItem("activity-report-selectedDepotId"));
      this.selectedDepotId = selectedDepotId;
    }
    var selectedWasteId = [];
    if (this.sessionStorageService.getItem("activity-report-selectedWasteId")) {
      selectedWasteId = JSON.parse(this.sessionStorageService.getItem("activity-report-selectedWasteId"));
      this.selectedWasteId = selectedWasteId;
    }

    

    var params: LocationServiceRequest = {
      customerId: this.pageHelperService.selectedCompanyId,
      startDate: moment(selectedStartDate),
      endDate: moment(selectedEndDate),
      blackboxId: selectedVehicleId,
      destinationLocationId: selectedTipLocationId,
      sourceLocationId: selectedWasteLocationId,
      depotId: selectedDepotId,
      wasteId: selectedWasteId,
      onlyShowIrregularInfo: false
    };
    console.log(params);

    return params;
  }

  MapDtoToModel(dto: LocationServiceInformationDto): ServicesItemModel {
    let model: ServicesItemModel = dto;
    model.timeAtSiteFormatted = DateTimeHelper.formatTimespan(model.timeAtSite);
    if (this.showFullDate) {
      model.arrivedAtFormatted = DateTimeHelper.formatDateAndTime(model.arrivedAt);
      model.departedAtFormatted = DateTimeHelper.formatDateAndTime(model.departedAt);
    } else {
      model.arrivedAtFormatted = DateTimeHelper.formatDateToTime(model.arrivedAt);
      model.departedAtFormatted = DateTimeHelper.formatDateToTime(model.departedAt);
    }
    return model;
  }
}
